import { render } from "./ChatMensagens.vue?vue&type=template&id=dfce77f0&scoped=true"
import script from "./ChatMensagens.vue?vue&type=script&lang=js"
export * from "./ChatMensagens.vue?vue&type=script&lang=js"

import "./ChatMensagens.vue?vue&type=style&index=0&id=dfce77f0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfce77f0"]])

export default __exports__